import type { FC } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UpdateableOrderTodos from "./UpdateableOrderTodos";
import type { SavedOrder } from "../orderTypes";

interface Props {
  readonly orderId: string;
  readonly todos: SavedOrder["todos"];
}

const ExpandableOrderTodos: FC<Props> = ({ orderId, todos }) => {
  return (
    <Accordion slotProps={{ transition: { unmountOnExit: true, mountOnEnter: true } }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Do zrobienia</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <UpdateableOrderTodos orderId={orderId} todos={todos} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ExpandableOrderTodos;
